import React from "react";

const formatPhone = (raw) => {
  const digits = raw.replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const PhoneInput = ({ value, onChange, required, className = "form-control", ...rest }) => {
  const handleChange = (e) => {
    const formatted = formatPhone(e.target.value);
    onChange(formatted);
  };

  return (
    <input
      type="tel"
      className={className}
      value={value}
      onChange={handleChange}
      placeholder="XXX-XXX-XXXX"
      maxLength={12}
      required={required}
      {...rest}
    />
  );
};

export default PhoneInput;
